// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Olfyq","label":"styles_label__zII2L"};